/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarSquare: {
  name: 'bar-square';
  data: string;
} = {
  name: 'bar-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h16v16H4V4Zm13 9a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm-5-6a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-3 4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z" fill="currentColor"/></svg>`,
};
